import { Injectable } from '@angular/core';
import { HuttonStorageApiService } from '@shared/features/media-storage';

@Injectable({
  providedIn: 'root',
})
export class TransactionStorageApiService extends HuttonStorageApiService {
  TYPE = 'transaction';
}
